import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import { getAccessSnapshot } from "../../context/AccessControl/accessSnapshot";
import { useStyles } from "./TicketsManagerTabsStyles";
import useTicketsManagerTabs from "./useTicketsManagerTabs";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import LockIcon from "@material-ui/icons/Lock"; // ✅ AGREGADO: Para icono de tickets cerrados
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import WarningIcon from "@material-ui/icons/Warning"; // ✅ AGREGADO: Para icono de alerta
import Typography from "@material-ui/core/Typography"; // ✅ AGREGADO: Para mejor tipografía
import Box from "@material-ui/core/Box"; // ✅ AGREGADO: Para layout mejorado
import Radio from "@material-ui/core/Radio"; // ✅ AGREGADO: Para selección de opciones
import RadioGroup from "@material-ui/core/RadioGroup"; // ✅ AGREGADO: Para grupo de opciones
import FormControlLabel from "@material-ui/core/FormControlLabel"; // ✅ AGREGADO: Para labels de opciones
import FormControl from "@material-ui/core/FormControl"; // ✅ AGREGADO: Para control de formulario
import api from "../../services/api"; // ✅ AGREGADO: Para llamadas a la API

import {
  Add as AddIcon,
} from "@material-ui/icons";

import NewTicketModal from "../NewTicketModal";
import TicketsListCustom from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import ConfirmationModal from "../ConfirmationModal"; // ✅ AGREGADO: Para confirmación de cerrar tickets
import SearchResultsPanel from "../SearchResultsPanel"; // ✅ AGREGADO: Para búsqueda global
// ✅ ELIMINADO: DuplicateTicketsCorrectionModal - Ya no se usa

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SocketContext } from "../../context/Socket/SocketContext";

import FilterPanel from "../FilterPanel";
import FilterListIcon from "@material-ui/icons/FilterList";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import BusinessIcon from "@material-ui/icons/Business";
import Chip from "@material-ui/core/Chip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";


const TicketsManagerTabs = () => {
  const classes = useStyles();
  const theme = useTheme(); // ✅ Para acceder al tema y detectar dark mode
  // Quién ve la pestaña de Agentes IA lo decide la matriz de Roles, no el código.
  const puedeVerAgentesIA = getAccessSnapshot().can("prompts:ver");
  const {
    activeQuickButton,
    aiAgentsCount,
    allTicketsCount,
    applyPanelStyle,
    closeTicketsOption,
    confirmationModalOpen,
    fetchTabCounts,
    fetchTabCountsRef,
    filterLoading,
    filterPanelOpen,
    filterResults,
    globalSearchLoading,
    globalSearchResults,
    groupsCount,
    handleChangeTabOpen,
    handleCloseOrOpenTicket,
    handleCloseTransferModal,
    handleClosedTickets,
    handleConfirmCloseAllTickets,
    handleNewSearch,
    handleNewTicket,
    handleOpenTickets,
    handleResolveTickets,
    handleSelectTicket,
    handleShowAllTickets,
    hasTicketsToClose,
    history,
    localSearchParam,
    newTicketModalOpen,
    openCount,
    pendingCount,
    queueFilterAnchorEl,
    searchInputRef,
    searchOnMessages,
    searchParam,
    selectedQueueIds,
    selectedTagIds,
    setActiveQuickButton,
    setAiAgentsCount,
    setAllTicketsCount,
    setCloseTicketsOption,
    setConfirmationModalOpen,
    setFilterLoading,
    setFilterPanelOpen,
    setFilterResults,
    setGlobalSearchLoading,
    setGlobalSearchResults,
    setGroupsCount,
    setLocalSearchParam,
    setNewTicketModalOpen,
    setOpenCount,
    setPendingCount,
    setQueueFilterAnchorEl,
    setSearchOnMessages,
    setSearchParam,
    setSelectedQueueIds,
    setSelectedTagIds,
    setShowAllTickets,
    setTab,
    setTabOpen,
    setTagFilterAnchorEl,
    setTags,
    setTransferTicketModalOpen,
    showAllTickets,
    socketManager,
    tab,
    tabCountsDebounceRef,
    tabOpen,
    tagFilterAnchorEl,
    tags,
    transferTicketModalOpen,
    user,
  } = useTicketsManagerTabs();

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          
          handleCloseOrOpenTicket(ticket);
        }}
      />
      {/* ✅ PESTAÑAS PRINCIPALES - OCULTADAS PARA USAR BOTONES DE ACCESO RÁPIDO */}
      {/* 
      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="scrollable" // ✅ NUEVO: Permitir scroll horizontal para pestañas principales
          scrollButtons="auto" // ✅ NUEVO: Mostrar botones de scroll automáticamente cuando sea necesario
          aria-label="scrollable main tabs" // ✅ NUEVO: Accesibilidad
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<LockIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      */}

      {/* ✅ BUSCADOR DE TICKETS Y MENSAJES */}
      <div className={classes.searchInputWrapperNew}>
        <SearchIcon className={classes.searchIconNew} />
        <InputBase
          className={classes.searchInputNew}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          value={localSearchParam}
          onChange={handleNewSearch}
        />
        <Tooltip placement="top" title={i18n.t("tickets.search.searchMessagesTooltip")}>
          <div>
            <Switch
              size="small"
              className={classes.searchSwitchNew}
              checked={searchOnMessages}
              onChange={(e) => setSearchOnMessages(e.target.checked)}
            />
          </div>
        </Tooltip>
      </div>

      {/* ✅ BARRA DE HERRAMIENTAS CON 6 BOTONES DE ACCESO RÁPIDO */}
      <div className={classes.quickActionsBar}>
        <div className={classes.quickActionsLeft}>
          {/* Botón 1: Todos — solo visible para admin */}
          {user?.profile === "admin" && (
            <ToggleButton
              value="showAll"
              selected={showAllTickets}
              onChange={handleShowAllTickets}
              className={classes.quickActionButton}
              size="small"
            >
              {showAllTickets ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </ToggleButton>
          )}

          {/* Botón 2: Nuevo */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.newTicket")}>
            <IconButton
              onClick={handleNewTicket}
              className={classes.quickActionIconButton}
              size="small"
            >
              <AddIcon />
            </IconButton>
          </Tooltip>

          {/* Botón 3: Resolver */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.resolveTickets")}>
            <IconButton
              onClick={handleResolveTickets}
              className={classes.quickActionIconButton}
              size="small"
            >
              <CheckBoxIcon />
            </IconButton>
          </Tooltip>

          {/* Botón 4: Abiertos */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.showOpen")}>
            <ToggleButton
              value="open"
              selected={activeQuickButton === "open"}
              onChange={handleOpenTickets}
              className={classes.quickActionButton}
              size="small"
            >
              <MoveToInboxIcon />
            </ToggleButton>
          </Tooltip>

          {/* Botón 5: Cerrados */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.showClosed")}>
            <ToggleButton
              value="closed"
              selected={activeQuickButton === "closed"}
              onChange={handleClosedTickets}
              className={classes.quickActionButton}
              size="small"
            >
              <LockIcon />
            </ToggleButton>
          </Tooltip>
        </div>

        <div className={classes.quickActionsRight}>
          {/* Botón de filtro de departamentos — solo visible para admin */}
          {user?.profile === "admin" && (
            <Tooltip title={i18n.t("tickets.managerTabs.tooltips.filterByQueues")}>
              <IconButton
                onClick={(e) => {
                  setQueueFilterAnchorEl(e.currentTarget);
                }}
                className={classes.quickActionIconButton}
                size="small"
                style={{
                  position: 'relative',
                  backgroundColor: selectedQueueIds?.length > 0 ? theme.palette.primary.main : undefined,
                  color: selectedQueueIds?.length > 0 ? '#fff' : undefined
                }}
              >
                <BusinessIcon />
                {selectedQueueIds?.length > 0 && (
                  <Chip
                    label={selectedQueueIds.length}
                    size="small"
                    style={{
                      position: 'absolute',
                      top: 4,
                      right: 4,
                      height: '16px',
                      fontSize: '0.65rem',
                      minWidth: '18px',
                      backgroundColor: selectedQueueIds?.length > 0 ? '#fff' : theme.palette.primary.main,
                      color: selectedQueueIds?.length > 0 ? theme.palette.primary.main : '#fff'
                    }}
                  />
                )}
              </IconButton>
            </Tooltip>
          )}
          
          {/* ✅ NUEVO: Menú desplegable para seleccionar departamentos */}
          <Menu
            anchorEl={queueFilterAnchorEl}
            open={Boolean(queueFilterAnchorEl)}
            onClose={() => setQueueFilterAnchorEl(null)}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 250,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              },
            }}
          >
            {user?.queues?.length === 0 && (
              <MenuItem disabled>
                <ListItemText 
                  primary={i18n.t("tickets.managerTabs.emptyQueues")}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.secondary, fontStyle: 'italic' }
                  }}
                />
              </MenuItem>
            )}
            {user?.queues?.map(queue => (
              <MenuItem
                key={queue.id}
                dense
                onClick={() => {
                  const isSelected = selectedQueueIds.indexOf(queue.id) > -1;
                  if (isSelected) {
                    setSelectedQueueIds(prev => prev.filter(id => id !== queue.id));
                  } else {
                    setSelectedQueueIds(prev => [...prev, queue.id]);
                  }
                }}
              >
                <Checkbox
                  style={{ color: queue.color || theme.palette.primary.main }}
                  size="small"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText 
                  primary={queue.name}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.primary }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
          
          {/* ✅ NUEVO: Botón de filtro de etiquetas con icono (similar a otros botones rápidos) */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.filterByTags")}>
            <IconButton
              onClick={(e) => {
                setTagFilterAnchorEl(e.currentTarget);
              }}
              className={classes.quickActionIconButton}
              size="small"
              style={{ 
                position: 'relative',
                backgroundColor: selectedTagIds?.length > 0 ? theme.palette.primary.main : undefined,
                color: selectedTagIds?.length > 0 ? '#fff' : undefined
              }}
            >
              <LocalOfferIcon />
              {selectedTagIds?.length > 0 && (
                <Chip 
                  label={selectedTagIds.length} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: selectedTagIds?.length > 0 ? '#fff' : theme.palette.primary.main,
                    color: selectedTagIds?.length > 0 ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
          
          {/* ✅ NUEVO: Menú desplegable para seleccionar etiquetas */}
          <Menu
            anchorEl={tagFilterAnchorEl}
            open={Boolean(tagFilterAnchorEl)}
            onClose={() => setTagFilterAnchorEl(null)}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 250,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              },
            }}
          >
            {tags.length === 0 && (
              <MenuItem disabled>
                <ListItemText 
                  primary={i18n.t("tickets.managerTabs.emptyTags")}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.secondary, fontStyle: 'italic' }
                  }}
                />
              </MenuItem>
            )}
            {tags.map(tag => (
              <MenuItem
                key={tag.id}
                dense
                onClick={() => {
                  const isSelected = selectedTagIds.indexOf(tag.id) > -1;
                  if (isSelected) {
                    setSelectedTagIds(prev => prev.filter(id => id !== tag.id));
                  } else {
                    setSelectedTagIds(prev => [...prev, tag.id]);
                  }
                }}
              >
                <Checkbox
                  style={{ color: tag.color || theme.palette.primary.main }}
                  size="small"
                  checked={selectedTagIds.indexOf(tag.id) > -1}
                />
                <ListItemText 
                  primary={tag.name}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.primary }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
          
          {/* ✅ NUEVO: Botón para abrir panel de filtros */}
          <Tooltip title={i18n.t("tickets.managerTabs.tooltips.activeFilters")}>
            <IconButton
              size="small"
              onClick={() => setFilterPanelOpen(!filterPanelOpen)}
              className={classes.quickActionIconButton}
              style={{ 
                backgroundColor: filterPanelOpen ? theme.palette.primary.main : undefined,
                color: filterPanelOpen ? '#fff' : undefined,
                position: 'relative'
              }}
            >
              <FilterListIcon />
              {((selectedQueueIds?.length > 0) || (selectedTagIds?.length > 0)) && (
                <Chip 
                  label={(selectedQueueIds?.length || 0) + (selectedTagIds?.length || 0)} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: filterPanelOpen ? '#fff' : theme.palette.primary.main,
                    color: filterPanelOpen ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* ✅ NUEVO: Panel de filtros */}
      <FilterPanel
        open={filterPanelOpen}
        onToggle={() => setFilterPanelOpen(!filterPanelOpen)}
        selectedQueueIds={selectedQueueIds}
        selectedTagIds={selectedTagIds}
        queues={user?.queues}
        tags={tags}
        onClearFilters={() => {
          setSelectedQueueIds([]);
          setSelectedTagIds([]);
        }}
        onRemoveQueue={(queueId) => {
          setSelectedQueueIds(prev => prev.filter(id => id !== queueId));
        }}
        onRemoveTag={(tagId) => {
          setSelectedTagIds(prev => prev.filter(id => id !== tagId));
        }}
      />

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable" // ✅ CAMBIADO: De "fullWidth" a "scrollable" para permitir scroll horizontal
          scrollButtons="auto" // ✅ NUEVO: Mostrar botones de scroll automáticamente cuando sea necesario
          aria-label="scrollable tabs" // ✅ NUEVO: Accesibilidad
        >
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={openCount}
                color="primary"
              >
                {i18n.t("ticketsList.assignedHeader")}
              </Badge>
            }
            value={"open"}
          />
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={pendingCount}
                color="secondary"
              >
                {i18n.t("ticketsList.pendingHeader")}
              </Badge>
            }
            value={"pending"}
          />
          {/* ✅ NUEVA PESTAÑA: TODOS (solo cuando showAllTickets = true) */}
          {showAllTickets && (
            <Tab
              label={
                <Badge
                  className={classes.badge}
                  badgeContent={allTicketsCount}
                  color="default"
                >
                  {i18n.t("ticketsList.allHeader")}
                </Badge>
              }
              value={"all"}
            />
          )}
          {/* ✅ NUEVA PESTAÑA: GRUPOS (solo si user.allowGroup = true) */}
          {user.allowGroup && (
            <Tab
              label={
                <Badge
                  className={classes.badge}
                  badgeContent={groupsCount}
                  color="secondary"
                >
                  {i18n.t("tickets.managerTabs.tabs.groups")}
                </Badge>
              }
              value={"groups"}
            />
          )}
          {/*
            AGENTES IA — gobernada por el permiso `prompts:ver`.

            🔴 Antes se renderizaba SIN NINGUNA guarda, para todo el mundo,
            mientras que GRUPOS sí tenía la suya (`user.allowGroup`).

            Un agente que atiende conversaciones no administra automatizaciones:
            el bot es autónomo y lo configura quien tiene acceso a Agentes IA.
            La regla NO se escribe aquí — se lee de la matriz de la pantalla de
            Roles, que es donde el cliente decide. Hoy el rol USER no tiene
            `prompts:ver` y el SUPERVISOR y el ADMIN sí, así que la pestaña
            desaparece para quien no le toca sin tocar ni un dato.
          */}
          {puedeVerAgentesIA && (
            <Tab
              label={
                <Badge
                  className={classes.badge}
                  badgeContent={aiAgentsCount}
                  color="primary"
                >
                  {i18n.t("tickets.managerTabs.tabs.aiAgents")}
                </Badge>
              }
              value={"ai-agents"}
            />
          )}
        </Tabs>
        <div className={classes.ticketsContainer}>
          {/* ✅ BÚSQUEDA GLOBAL: Mostrar resultados agrupados si hay búsqueda activa */}
          {globalSearchResults && (
            <div style={{ 
              flex: "none",
              maxHeight: "60%",
              overflowY: "auto",
              marginBottom: 8,
              padding: "0 8px"
            }}>
              <SearchResultsPanel
                results={globalSearchResults}
                searchParam={localSearchParam}
                loading={globalSearchLoading}
                onTicketClick={handleSelectTicket}
              />
            </div>
          )}
          
          {/* ✅ FILTROS: Mostrar resultados filtrados si hay filtros activos (solo si no hay búsqueda) */}
          {!globalSearchResults && filterResults && (
            <div style={{ 
              flex: "none",
              maxHeight: "60%",
              overflowY: "auto",
              marginBottom: 8,
              padding: "0 8px"
            }}>
              <SearchResultsPanel
                results={filterResults}
                searchParam=""
                loading={filterLoading}
                onTicketClick={handleSelectTicket}
                isFilterMode={true}
              />
            </div>
          )}
          
          {/* Siempre montados: los socket handlers de TODOS los tabs están activos.
              CSS display controla la visibilidad para evitar perder eventos al cambiar tab. */}
          <div style={{ display: tabOpen === "open" ? "flex" : "none", flex: 1, height: "100%", flexDirection: "column", minHeight: 0 }}>
            <TicketsListCustom
              status="open"
              showAll={user?.profile === "admin"}
              selectedQueueIds={filterResults ? selectedQueueIds : undefined}
              style={applyPanelStyle("open")}
              searchOnMessages={searchOnMessages}
              searchParam={globalSearchResults ? "" : searchParam}
              isActiveTab={tabOpen === "open"}
              excludeAIAgents={true}
            />
          </div>
          <div style={{ display: tabOpen === "pending" ? "flex" : "none", flex: 1, height: "100%", flexDirection: "column", minHeight: 0 }}>
            <TicketsListCustom
              status="pending"
              selectedQueueIds={filterResults ? selectedQueueIds : undefined}
              style={applyPanelStyle("pending")}
              searchOnMessages={searchOnMessages}
              searchParam={searchParam}
              isActiveTab={tabOpen === "pending"}
              excludeAIAgents={true}
            />
          </div>
          {showAllTickets && (
            <div style={{ display: tabOpen === "all" ? "flex" : "none", flex: 1, height: "100%", flexDirection: "column", minHeight: 0 }}>
              <TicketsListCustom
                status="all"
                showAll={user?.profile === "admin"}
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("all")}
                searchOnMessages={searchOnMessages}
                searchParam={searchParam}
                isActiveTab={tabOpen === "all"}
              />
            </div>
          )}
          {user.allowGroup && (
            <div style={{ display: tabOpen === "groups" ? "flex" : "none", flex: 1, height: "100%", flexDirection: "column", minHeight: 0 }}>
              <TicketsListCustom
                status="group"
                selectedQueueIds={filterResults ? selectedQueueIds : undefined}
                style={applyPanelStyle("groups")}
                searchOnMessages={searchOnMessages}
                searchParam={searchParam}
                isActiveTab={tabOpen === "groups"}
              />
            </div>
          )}
          <div style={{ display: tabOpen === "ai-agents" ? "flex" : "none", flex: 1, height: "100%", flexDirection: "column", minHeight: 0 }}>
            <TicketsListCustom
              status="ai"
              selectedQueueIds={filterResults ? selectedQueueIds : undefined}
              style={applyPanelStyle("ai-agents")}
              aiAgentFilter={true}
              excludeAIAgents={false}
              searchOnMessages={searchOnMessages}
              searchParam={searchParam}
              isActiveTab={tabOpen === "ai-agents"}
            />
          </div>
        </div>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsListCustom
          status="closed"
          showAll={user?.profile === "admin"}
          selectedQueueIds={filterResults ? selectedQueueIds : undefined}
          searchOnMessages={searchOnMessages}
          searchParam={tab === "closed" ? searchParam : ""}
          isActiveTab={tab === "closed"}
        />
      </TabPanel>
      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferModal}
        ticketid={null}
      />
      
      {/* ✅ MODAL DE CONFIRMACIÓN MEJORADO PARA CERRAR TODOS LOS TICKETS */}
      <ConfirmationModal
        title={i18n.t("ticketsManager.confirmation.title")}
        open={confirmationModalOpen}
        onClose={() => {
          setConfirmationModalOpen(false);
          setCloseTicketsOption("open"); // ✅ Resetear opción al cerrar
        }}
        onConfirm={handleConfirmCloseAllTickets}
        confirmDisabled={!hasTicketsToClose()} // ✅ DESHABILITAR SI NO HAY TICKETS
        maxWidth="sm"
        fullWidth
      >
        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
          {/* ✅ ICONO DE ALERTA GRANDE */}
          <WarningIcon 
            style={{ 
              fontSize: 64, 
              color: '#ff9800', 
              marginBottom: 16 
            }} 
          />
          
          {/* ✅ TÍTULO PRINCIPAL */}
          <Typography 
            variant="h6" 
            component="h2" 
            align="center" 
            gutterBottom
            style={{ 
              fontWeight: 'bold', 
              color: theme.mode === 'dark' ? '#f87171' : '#d32f2f' 
            }}
          >
            {i18n.t("ticketsManager.confirmation.title")}
          </Typography>
          
          {/* ✅ SUBTÍTULO EXPLICATIVO */}
          <Typography 
            variant="body1" 
            align="center" 
            gutterBottom
            style={{ 
              marginBottom: 16, 
              color: theme.palette.text.secondary || theme.palette.text.primary 
            }}
          >
            {i18n.t("ticketsManager.confirmation.subtitle")}
          </Typography>
          
          {/* ✅ PREGUNTA PRINCIPAL */}
          <Typography 
            variant="body1" 
            align="center" 
            gutterBottom
            style={{ 
              fontWeight: 'bold', 
              marginBottom: 16,
              color: theme.palette.text.primary
            }}
          >
            {i18n.t("ticketsManager.confirmation.whichTicketsQuestion")}
          </Typography>

          {/* ✅ MENSAJE INFORMATIVO SI NO HAY TICKETS */}
          {!hasTicketsToClose() && (
            <Box
              style={{
                padding: '12px 16px',
                marginBottom: 16,
                borderRadius: '8px',
                backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : '#e3f2fd',
                border: `1px solid ${theme.mode === 'dark' ? '#3b82f6' : '#90caf9'}`,
                textAlign: 'center'
              }}
            >
              <Typography 
                variant="body2" 
                style={{ 
                  color: theme.mode === 'dark' ? '#93c5fd' : '#1565c0',
                  fontWeight: '500'
                }}
              >
                <span role="img" aria-label={i18n.t("ticketsManager.confirmation.warningEmojiAria")}>⚠️</span>{" "}
                {i18n.t("ticketsManager.confirmation.noTicketsForOption")}
              </Typography>
            </Box>
          )}
          
          {/* ✅ OPCIONES DE SELECCIÓN */}
          <FormControl component="fieldset" style={{ width: '100%', marginBottom: 16 }}>
            <RadioGroup
              value={closeTicketsOption}
              onChange={(e) => setCloseTicketsOption(e.target.value)}
              style={{ width: '100%' }}
            >
              <Box
                onClick={() => setCloseTicketsOption("open")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "open" 
                    ? (theme.mode === 'dark' ? '#4B5563' : '#e3f2fd')
                    : (theme.mode === 'dark' ? '#374151' : '#fff'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "open") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "open") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                  }
                }}
              >
                <FormControlLabel 
                  value="open" 
                  control={<Radio style={{ color: theme.palette.primary.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary }}>{i18n.t("ticketsManager.confirmation.optionAttendingOpen")}</span>
                      <Badge badgeContent={openCount} color="primary" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
              <Box
                onClick={() => setCloseTicketsOption("pending")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "pending" 
                    ? (theme.mode === 'dark' ? '#4B5563' : '#fce4ec')
                    : (theme.mode === 'dark' ? '#374151' : '#fff'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "pending") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "pending") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                  }
                }}
              >
                <FormControlLabel 
                  value="pending" 
                  control={<Radio style={{ color: theme.palette.secondary.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary }}>{i18n.t("ticketsManager.confirmation.optionPending")}</span>
                      <Badge badgeContent={pendingCount} color="secondary" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
              <Box
                onClick={() => setCloseTicketsOption("both")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${closeTicketsOption === "both" 
                    ? (theme.mode === 'dark' ? '#dc2626' : '#ff9800')
                    : (theme.mode === 'dark' ? '#7c2d12' : '#ff9800')}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "both" 
                    ? (theme.mode === 'dark' ? '#991b1b' : '#fff3e0')
                    : (theme.mode === 'dark' ? '#78350f' : '#fff3e0'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "both") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#991b1b' : '#ffe0b2';
                    e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#dc2626' : '#ff9800';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "both") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#78350f' : '#fff3e0';
                    e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#7c2d12' : '#ff9800';
                  }
                }}
              >
                <FormControlLabel 
                  value="both" 
                  control={<Radio style={{ color: theme.palette.error.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>{i18n.t("ticketsManager.confirmation.optionBoth")}</span>
                      <Badge badgeContent={openCount + pendingCount} color="error" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
            </RadioGroup>
          </FormControl>
          
          {/* ✅ ADVERTENCIA FINAL */}
          <Typography 
            variant="body2" 
            align="center"
            style={{ 
              color: theme.mode === 'dark' ? '#f87171' : '#d32f2f', 
              fontWeight: 'bold',
              backgroundColor: theme.mode === 'dark' ? '#4a1f1f' : '#ffebee',
              padding: '8px 16px',
              borderRadius: '4px',
              border: `1px solid ${theme.mode === 'dark' ? '#7f1d1d' : '#ffcdd2'}`
            }}
          >
            {i18n.t("ticketsManager.confirmation.warning")}
          </Typography>
        </Box>
      </ConfirmationModal>

      {/* ✅ ELIMINADO: Modal de corrección de duplicados - Ya no se usa */}
    </Paper>
  );
};

export default TicketsManagerTabs;
